// src/components/projects/ProjectsTableOfContents.js
import React from 'react';
import styles from '../../styles/pages/Projects.module.css';

/**
 * Table of contents component for the projects sidebar
 * 
 * @param {Object} props - Component props 
 * @param {Array} props.projects - Array of project objects with id, title
 */
export function ProjectsTableOfContents({ projects }) {
  const handleAnchorClick = (e, projectId) => {
    e.preventDefault();
    
    // Check if this is the first project - if so, scroll to top of page
    const isFirstProject = projects.length > 0 && projects[0].id === projectId;
    
    if (isFirstProject) {
      // Scroll to the very top of the page for the first project
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Find the project element and scroll to it
      const projectElement = document.getElementById(`project-${projectId}`);
      
      if (projectElement) {
        // Calculate scroll position accounting for sticky header
        const headerHeight = 64; // --header-height from CSS variables
        const spaceMd = 16; // --space-md (1rem = 16px)
        const extraOffset = 20; // Additional offset for better positioning
        const totalOffset = headerHeight + spaceMd + extraOffset;
        
        // Use window.scrollTo for precise positioning
        window.scrollTo({
          top: projectElement.offsetTop - totalOffset,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div className={styles.projectsSidebar}>
      <div className={styles.sidebarContent}>
        <h3>Projects</h3>
        {projects.length > 0 ? (
          <ul className={styles.tocList}>
            {projects.map((project) => (
              <li key={project.id} className={styles.tocItem}>
                <a 
                  href={`#project-${project.id}`} 
                  onClick={(e) => handleAnchorClick(e, project.id)}
                  className={styles.tocLink}
                >
                  {project.title}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.tocEmpty}>No projects available</p>
        )}
      </div>
    </div>
  );
}
